import { makeHandle } from '@helpers/helpers'
import { Store } from 'redux'
import { Persistor } from 'redux-persist'
import { PersistPartial } from 'redux-persist/es/persistReducer'

import { RootState } from '../reducers/types'

export const [getStore, setStore, isStoreSet] = makeHandle<Store<RootState & PersistPartial>>('store')
export const [getPersistor, setPersistor, isPersistorSet] = makeHandle<Persistor>('persistor')
